export function reportUploadCapabilities(reportType, dataVqa) {
  if (reportType === "Report Anonymized") {
    return dataVqa?.library_capabilities ?? dataVqa?.capabilities;
  }
  return dataVqa?.capabilities;
}
